import React from 'react'
import {history} from "../../configureHistory";
import {orderStatuses} from "../constants/orderStatuses";
import {t} from "../../i18n";
import image from "../Resourses/green_human.png";

export default class Accepted extends React.Component<any, any>{
    mainIntId = 0;
    longIntId = 0;

    constructor(props:any) {
        super(props);
            this.state = {
                preview:this.props.location.state && this.props.location.state.preview
            };
            //window.history.replaceState(null, '', `/${state.data.LinkCode}`);
    }

    componentDidUpdate(): void {
        this.moveToNotReady();
    }

    componentDidMount(): void {
        if(sessionStorage && !history.location.state) {
            const reqID = sessionStorage.getItem('reqID');
            if(reqID)
                history.push({pathname: `/${reqID}`});
        }
        this.moveToNotReady();
        //Preview
        if(this.state.preview) {
            return;
        }
        // @ts-ignore
        let mainIntInterval = window.app.env.API_CALL_INTERVAL;
        // @ts-ignore
        let longIntInterval = window.app.env.RECHECK_WINDOW_INTERVAL;

        this.mainIntId = setInterval(() => {
            this.props.callGetOrder(this.props.feed.LinkCode);
        }, mainIntInterval);

        this.longIntId = setInterval(() => {
            this.redirectToManualCheck();
        }, longIntInterval);
    }

    componentWillUnmount(): void {
        //Preview
        if(this.state.preview)
            return;
        clearInterval(this.mainIntId);
        clearInterval(this.longIntId);
    }

    redirectToManualCheck = () => {
      const state: any = history.location.state;
      if(state && state.data)
        history.push({
            pathname:"/recheck",
            state:{data: state.data, alreadyOpened:true}
        });
    };

    moveToNotReady = () => {
        if(this.state.preview)
            return;
        //render() bails out without location state, so keep the redirect in step with it
        if(!history.location.state)
            return;
        if (this.props.feed.OrderStatus < "200") {
            history.push({pathname:'/summary',state: {data: this.props.feed, OrderStatus:orderStatuses.LessThen200}});
        }
        else if (this.props.feed.OrderStatus == "500" || this.props.feed.OrderStatus == "600") {
            history.push({ pathname: '/summary', state: { data: this.props.feed, OrderStatus: orderStatuses.Canceled } });
        }
        else if (this.props.feed.OrderStatus == "650") {
            history.push({ pathname: '/summary', state: { data: this.props.feed, OrderStatus: orderStatuses.Removed } });
        }
        else if (this.props.feed.OrderStatus >= "400") {
            history.push({pathname:'/summary',state: {data: this.props.feed, OrderStatus:orderStatuses.Delivered}});
        }
    };

    extraTextIf2Time = ()=> {
        if (true) {
            return t("StaffOnTheWay_TextAtTheBottom");
        }
    };

    imageStyles = {
        height: '150px',
        maxHeight: '150px',
        width: 'auto'
    };
    showImage = ()=>{
        let style = this.props.cssStyles.StaffOnTheWay;
        if(style.Show && style.UseCustom){
            return <img style={this.imageStyles} src={String(style.Image)} />;}
        else if(style.Show && !style.UseCustom){
            return <img src={image} alt="In transit" />
        }
    };

    render(){
      const state: any = history.location.state;
      if(!state){
          return (<div></div>);
      }
        const {OrderNumber, StoreName} = state && state.data;
        const styleCommon = {
            fontFamily: this.props.cssStyles.CommonSettings.FontFamily,
            color: this.props.cssStyles.CommonSettings.FontColor
        };
        return <div className="container text-center">
            <div className="row">
                <div className="col-12" style={styleCommon}>
                    <h1>{t("StaffOnTheWay_TextInTheTopOfCommonText")}</h1>
                    <p>{t("CommonText_FirstLine")}</p>
                    <h3>{t("CommonText_SecondLine")}</h3>
                </div>
            </div>
            <div className="row justify-content-center">
                {this.showImage()}
            </div>
            <div className="row justify-content-md-center">
                <div className="col-md-auto">
                    <h3 style={styleCommon}>{this.extraTextIf2Time()}</h3>
                </div>
            </div>
        </div>
    }
};
